// extracted by mini-css-extract-plugin
export var description = "c_L";
export var memberBio = "c_Q";
export var memberImage = "c_N";
export var memberName = "c_P";
export var members = "c_M";